// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Withdrawal Fees */
.withdrawalfees-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border);
  overflow: hidden;
}

.withdrawalfees-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
  border-bottom: 1px solid var(--border);
}

.withdrawalfees-section__title-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.withdrawalfees-section__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.15);
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.withdrawalfees-section__title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text);
}

.withdrawalfees-section__stats {
  display: flex;
  gap: 1.25rem;
}

.withdrawalfees-stat {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.withdrawalfees-stat strong {
  color: #0f766e;
  font-weight: 700;
  margin-right: 0.25rem;
}

.withdrawalfees-search-wrap {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.75rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid var(--border);
}

.withdrawalfees-search-wrap i {
  color: var(--text-muted);
  font-size: 0.9rem;
}

.withdrawalfees-search-input {
  flex: 1 1;
  min-width: 0;
  max-width: 320px;
  padding: 0.55rem 0.75rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}

.withdrawalfees-search-input::placeholder {
  color: var(--text-muted);
}

.withdrawalfees-search-input:focus {
  outline: none;
  border-color: #0f766e;
}

.withdrawalfees-table-wrap {
  overflow-x: auto;
}

.withdrawalfees-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.withdrawalfees-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
}

.withdrawalfees-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.withdrawalfees-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text);
  vertical-align: middle;
}

.withdrawalfees-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.withdrawalfees-table tbody tr:hover {
  background: #f0fdfa !important;
}

.withdrawalfees-table tbody tr:last-child td {
  border-bottom: none;
}

.withdrawalfees-mono {
  font-family: ui-monospace, monospace;
  font-size: 0.8rem;
  color: #0369a1;
  font-weight: 500;
}

.withdrawalfees-empty {
  padding: 2rem 1.5rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.9rem;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Trading/WithdrawalFeesPage.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX","sourcesContent":["/* Withdrawal Fees */\n.withdrawalfees-section {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.withdrawalfees-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);\n  border-bottom: 1px solid var(--border);\n}\n\n.withdrawalfees-section__title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.withdrawalfees-section__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.15);\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.withdrawalfees-section__title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.withdrawalfees-section__stats {\n  display: flex;\n  gap: 1.25rem;\n}\n\n.withdrawalfees-stat {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.withdrawalfees-stat strong {\n  color: #0f766e;\n  font-weight: 700;\n  margin-right: 0.25rem;\n}\n\n.withdrawalfees-search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.75rem 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid var(--border);\n}\n\n.withdrawalfees-search-wrap i {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.withdrawalfees-search-input {\n  flex: 1;\n  min-width: 0;\n  max-width: 320px;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}\n\n.withdrawalfees-search-input::placeholder {\n  color: var(--text-muted);\n}\n\n.withdrawalfees-search-input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.withdrawalfees-table-wrap {\n  overflow-x: auto;\n}\n\n.withdrawalfees-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.withdrawalfees-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f8fafc;\n}\n\n.withdrawalfees-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.withdrawalfees-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text);\n  vertical-align: middle;\n}\n\n.withdrawalfees-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.withdrawalfees-table tbody tr:hover {\n  background: #f0fdfa !important;\n}\n\n.withdrawalfees-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.withdrawalfees-mono {\n  font-family: ui-monospace, monospace;\n  font-size: 0.8rem;\n  color: #0369a1;\n  font-weight: 500;\n}\n\n.withdrawalfees-empty {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
